const withdrawalAgreement = {
  id: 'withdrawal-agreement-lv',
  title: 'Līdzekļu izņemšanas līgums',
  body: `
  <ol>
    <li>Korespondentbanka var iekasēt komisijas maksu par līdzekļu aprēķināšanu. Lūdzu, pārbaudiet komisijas maksas esamību un tās apmēru savā bankā.</li>
    <li>Ja līdzekļu izņemšana notiek nevis Partneru kabineta valūtā (krievu rubļi), tad tie tiks konvertēti. Valūtas konvertācija tiek aprēķināta pēc Eiropas Centrālās bankas aktuālā kursa līdzekļu ieskaitīšanas dienā.</li>
    <li>Izmaksas tiek veiktas tikai uz Partnera kabinetā norādītās un verificētās personas bankas karti vai kontu. Uz trešo personu kontiem līdzekli netiek pārskaitīti.</li>
    <li>
        Līdzekļu izņemšanai ir nepieciešams uzrādīt dokumentus un rekvizītus.
        <ol>
          <li>Juridiskām personām līdzekļu izņemšanai jāuzrāda: nodokļu maksātāja registrācijas numurs (Krievijas Federācijā saukts - ИНН),  uzņēmuma registrācijas numurs (ОГРН - Krievijas Federācijas rezidentiem) vai līdzīgi dokumenti (citu valstu rezidentiem), bankas rekvizīti uz e-pastu tatyanak@super-ego.info un jāaizpilda pieteikums.</li>
          <li>Līdzekļu izņemšanai uz bankas karti, ir nepieciešams ievadīt tās rekvizītus speciāli tam paredzētajā norēķinu pakalpojuma lapā (atbilst karšu drošības industrijas standartiem PCI DSS) un aizpildīt pieteikumu. Mēs neuzglabājam un neapstrādājam jūsu bankas kartes datus.</li>
        </ol>
    </li>
    <li>Izņemot naudas līdzekļus uz bankas karti komisijas nauda ir 4% no pieteikumā uzrādītās summas.</li>
    <li>No sanemtajiem līdzekļiem patstāvīgi ir jānomaksā nodoklis, kuru nosaka dzīvesvietas valsts.</li>
    <li>Līdzekļi tiek ieskaitīti bankas kartē vai kontā 10 darba dienu laikā (aptuvenais laiks, precīzi datumi ir atkarīgi no jūsu bankas).</li>
  </ol>

  <p>Līdzeklu izņemšanas jautājumos lūgums sazināties ar Kompetentā Atbalsta Dienestu pa tālruni +79662406130 (par zvanu var tikt piemērota maksa, precizējiet zvana maksu pie sava mobilā operatora).</p>
  `,
}

export default withdrawalAgreement
